import { render } from "./SliderSelector.vue?vue&type=template&id=cbaea1fa"
import script from "./SliderSelector.vue?vue&type=script&lang=js"
export * from "./SliderSelector.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2456369213/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__